module.exports = __webpack_public_path__ + "static/media/minneapolis-mobile.cc8a1b86.webp";